import SpriteSymbol from "../../../../../doctor/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../doctor/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "IconHelp",
  "use": "IconHelp-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"IconHelp\"><path d=\"M12 2C6.475 2 2 6.475 2 12s4.475 10 10 10 10-4.475 10-10S17.525 2 12 2zm1 17h-2v-2h2v2zm2.065-7.745l-.895.92C13.45 12.895 13 13.5 13 15h-2v-.5c0-1.105.45-2.105 1.17-2.83l1.245-1.26A2 2 0 1 0 10 9H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.355 1.675-.935 2.255z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol